import { render, staticRenderFns } from "./edit.faqs.page.vue?vue&type=template&id=e67a188c&"
import script from "./edit.faqs.page.vue?vue&type=script&lang=js&"
export * from "./edit.faqs.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports